var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSettings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.568,500.5c0-110.61,120.715-26.921,64.516-162.6-56.231-135.681-82.391,8.823-160.606-69.384s66.333-104.365-69.36-160.562c-135.718-56.2-52.024,64.481-162.61,64.481-110.619,0-26.921-120.68-162.612-64.481s8.827,82.349-69.391,160.562S163.133,202.216,106.93,337.9C50.7,473.579,171.416,389.89,171.416,500.5S50.7,527.419,106.93,663.1c56.2,135.681,82.359-8.823,160.575,69.352,78.218,78.214-66.3,104.4,69.391,160.6s51.993-64.483,162.612-64.483c110.586,0,26.892,120.678,162.61,64.483,135.693-56.2-8.854-82.384,69.36-160.6,78.215-78.175,104.375,66.329,160.606-69.352C948.283,527.419,827.568,611.11,827.568,500.5ZM500,301.015c110.457,0,200,89.537,200,199.985S610.457,700.985,500,700.985,300,611.448,300,501,389.543,301.015,500,301.015Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Settings.e3ac401b.svg";
export { ForwardRef as ReactComponent };